// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.SideMenuAdminReports {
    padding: 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.SideMenuAdminReports_header {
    margin-bottom: 20px;
    border-bottom: 1px solid #ddd;
    padding-bottom: 10px;
}

.SideMenuAdminReports_header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: #333;
}

.SideMenuAdminReports_list {
    flex: 1;
    overflow-y: auto;
    background-color: #f9f9f9;
    border: 1px solid #ddd;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.SideMenuAdminReports_loading {
    text-align: center;
    padding: 40px 20px;
    color: #666;
    font-size: 16px;
}

.SideMenuAdminReports_no_reports {
    text-align: center;
    padding: 40px 20px;
    color: #666;
    font-size: 16px;
}

.SideMenuAdminReports_item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    border-bottom: 1px solid #eee;
    background: white;
    transition: background-color 0.3s;
}

.SideMenuAdminReports_item:hover {
    background-color: #f5f5f5;
}

.SideMenuAdminReports_item:last-child {
    border-bottom: none;
}

.SideMenuAdminReports_item_info {
    flex: 1;
    margin-right: 15px;
}

.SideMenuAdminReports_item_date {
    font-size: 12px;
    color: #666;
    margin-bottom: 5px;
}

.SideMenuAdminReports_item_user {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin-bottom: 8px;
}

.SideMenuAdminReports_item_message {
    font-size: 14px;
    color: #555;
    line-height: 1.4;
    word-wrap: break-word;
}

.SideMenuAdminReports_item_buttons {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}

.SideMenuAdminReports_button {
    padding: 6px 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    transition: background-color 0.3s;
}

.SideMenuAdminReports_button_open {
    background: #4CAF50;
    color: white;
}

.SideMenuAdminReports_button_open:hover {
    background: #45a049;
}

.SideMenuAdminReports_button_delete {
    background: #f44336;
    color: white;
}

.SideMenuAdminReports_button_delete:hover {
    background: #d32f2f;
}

.notification {
    position: fixed;
    top: 20px;
    right: 20px;
    padding: 15px 20px;
    border-radius: 5px;
    color: white;
    z-index: 10000;
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: 300px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.notification.success {
    background-color: #4CAF50;
}

.notification.error {
    background-color: #f44336;
}

.notification-close {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    font-size: 18px;
    padding: 0;
    margin-left: 10px;
}

.notification-close:hover {
    opacity: 0.8;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/administrator/SideMenuAdminReports.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,wCAAwC;AAC5C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["\n.SideMenuAdminReports {\n    padding: 20px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.SideMenuAdminReports_header {\n    margin-bottom: 20px;\n    border-bottom: 1px solid #ddd;\n    padding-bottom: 10px;\n}\n\n.SideMenuAdminReports_header h3 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n}\n\n.SideMenuAdminReports_list {\n    flex: 1;\n    overflow-y: auto;\n    background-color: #f9f9f9;\n    border: 1px solid #ddd;\n    border-radius: 5px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n}\n\n.SideMenuAdminReports_loading {\n    text-align: center;\n    padding: 40px 20px;\n    color: #666;\n    font-size: 16px;\n}\n\n.SideMenuAdminReports_no_reports {\n    text-align: center;\n    padding: 40px 20px;\n    color: #666;\n    font-size: 16px;\n}\n\n.SideMenuAdminReports_item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 15px;\n    border-bottom: 1px solid #eee;\n    background: white;\n    transition: background-color 0.3s;\n}\n\n.SideMenuAdminReports_item:hover {\n    background-color: #f5f5f5;\n}\n\n.SideMenuAdminReports_item:last-child {\n    border-bottom: none;\n}\n\n.SideMenuAdminReports_item_info {\n    flex: 1;\n    margin-right: 15px;\n}\n\n.SideMenuAdminReports_item_date {\n    font-size: 12px;\n    color: #666;\n    margin-bottom: 5px;\n}\n\n.SideMenuAdminReports_item_user {\n    font-size: 14px;\n    color: #333;\n    font-weight: 500;\n    margin-bottom: 8px;\n}\n\n.SideMenuAdminReports_item_message {\n    font-size: 14px;\n    color: #555;\n    line-height: 1.4;\n    word-wrap: break-word;\n}\n\n.SideMenuAdminReports_item_buttons {\n    display: flex;\n    gap: 8px;\n    flex-shrink: 0;\n}\n\n.SideMenuAdminReports_button {\n    padding: 6px 12px;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    font-weight: 500;\n    transition: background-color 0.3s;\n}\n\n.SideMenuAdminReports_button_open {\n    background: #4CAF50;\n    color: white;\n}\n\n.SideMenuAdminReports_button_open:hover {\n    background: #45a049;\n}\n\n.SideMenuAdminReports_button_delete {\n    background: #f44336;\n    color: white;\n}\n\n.SideMenuAdminReports_button_delete:hover {\n    background: #d32f2f;\n}\n\n.notification {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    padding: 15px 20px;\n    border-radius: 5px;\n    color: white;\n    z-index: 10000;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    max-width: 300px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.notification.success {\n    background-color: #4CAF50;\n}\n\n.notification.error {\n    background-color: #f44336;\n}\n\n.notification-close {\n    background: none;\n    border: none;\n    color: white;\n    cursor: pointer;\n    font-size: 18px;\n    padding: 0;\n    margin-left: 10px;\n}\n\n.notification-close:hover {\n    opacity: 0.8;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
